import Section from '../components/section/Section';

export default function AboutMe() {
    return (
      <>
        <div className="content">
            <Section color={"pink"}>
                <div className="col-xs-12 col-lg-12">
                    <div className="box">
                        <h1 className="margin-bottom-20">Over Mij</h1>
                        <p>
                            Pellentesque feugiat enim eu aliquet posuere. Praesent in elit sed nulla imperdiet porttitor. Duis iaculis finibus gravida. Mauris vitae dolor eget arcu luctus condimentum. Mauris tempor quam sapien, vel finibus enim faucibus et. Nulla elit mauris, faucibus in risus id, viverra faucibus risus. Ut et mollis nunc. Morbi interdum dolor tempor ligula vestibulum blandit. Ut tristique sem nunc, vehicula bibendum massa iaculis ac. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Integer hendrerit vel neque ac efficitur. Duis nec dolor quis magna lobortis vehicula ut id ligula. Nulla consequat erat in nunc tincidunt vehicula. Vivamus ut lectus dictum, sagittis libero in, malesuada nunc. Curabitur auctor, eros malesuada tincidunt feugiat, ipsum mauris cursus nunc, ut rutrum nibh elit scelerisque purus. Vivamus semper varius lorem in dapibus.
                        </p>
                    </div>
                </div>
            </Section>
        </div>
      </>
    );
  }